import React, { useEffect, useRef, useState } from 'react';
import ToggleButton from '../../../components/admin/dashboard/orderSummary/toggleButton';
import { Typography, Card, Grid, Box } from "@mui/material";
import IconCard from '../../../components/admin/dashboard/orderSummary/iconCard'
import CardTemp from '../../../components/admin/dashboard/orderSummary/card';
import MealCount from '../../../components/admin/dashboard/orderSummary/session/index';
import { useDispatch, useSelector } from 'react-redux';
import { getLastDayOrderSummaryWatcher } from '../../../redux/actionCreators/admin/orderSummary';
import { getDropDownWatcher } from '../../../redux/actionCreators/admin/employeeManagement';
import { OVERALL_CAFETERIA_ID } from '../../../utils/constants';

const OrderSummary = ({ LastDayData }) => {
    const dispatch = useDispatch();
    const [tabVal, setTabval] = useState(1);
    const [dateChange, setDateChange] = useState(new Date())

    const { EmployeeReducers: { vendorName } } = useSelector((state) => state)

    // The summary is filtered by vendor; the first one is shown until another is picked
    const vendorOptions = (vendorName || []).filter((v) => +v.id !== OVERALL_CAFETERIA_ID)
    const [selectedVendorId, setSelectedVendorId] = useState(null)
    const vendorId = selectedVendorId === null ? vendorOptions[0]?.id : selectedVendorId

    useEffect(() => {
        dispatch(getDropDownWatcher());
    }, [dispatch])

    const loadSummary = useRef();
    loadSummary.current = () => {
        if (vendorId === undefined) return
        dispatch(getLastDayOrderSummaryWatcher({ nCafeteriaId: OVERALL_CAFETERIA_ID, nVendorId: vendorId, CurentDate: dateChange }));
    }

    useEffect(() => {
        loadSummary.current();
    }, [vendorId, dateChange])

    return (
        <>
            <Card style={{ boxShadow: (theme) => `0px 12px 23px ${theme.palette.grey[200]}` }}>
                <Grid container spacing={3} sx={{ padding: '30px' }} >
                    <Grid item lg={6} xs={12} sx={{ justifyContent: 'left' }}>
                        <div>
                            <Typography variant='t20_600'>Orders Summary</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sx={{ justifyContent: 'right', display: 'flex' }}>
                        <ToggleButton dateChange={dateChange} setDateChange={setDateChange} setTabval={setTabval} />
                    </Grid>
                </Grid>

                <Box >
                    <IconCard tabVal={tabVal} />
                </Box>

                <Box>
                    <CardTemp tabVal={tabVal} />
                </Box>

                <Box>
                    <MealCount dayTabVal={tabVal} vendorOptions={vendorOptions} vendorId={vendorId} setVendorId={setSelectedVendorId} />
                </Box>
            </Card>
        </>

    )
}

export default OrderSummary;